const w = {
  enableDocumentUpload: {
    AT: !0,
    BE: !0,
    CH: !0,
    DE: !0,
    ES: !0,
    FR: !0,
    GB: !0,
    IS: !0,
    IT: !0,
    NL: !0,
    NO: !0,
    PT: !0,
    SE: !0,
    DEFAULT: !1
  },
  enableEnterpriseVerificationNotification: {
    DEFAULT: !1
  },
  enableOrderDocumentDownload: {
    AT: !0,
    BE: !0,
    CH: !0,
    DE: !0,
    ES: !0,
    FR: !0,
    GB: !0,
    IT: !0,
    NL: !0,
    PT: !0,
    SE: !0,
    DEFAULT: !1
  },
  enableWorkshopAppointmentRequest: {
    CH: !0,
    DEFAULT: !1
  },
  showAccelerationAndTopSpeed: {
    NL: !1,
    DEFAULT: !0
  },
  // NOTE: UK specific to display extra leasing attributes
  showAdditionalLeasingOptions: {
    GB: !0,
    DEFAULT: !1
  },
  // NOTE: PT specific (hidden in address-details-form in Shopping Cart)
  showAddressPrefix: {
    PT: !1,
    DEFAULT: !0
  },
  showAdvancedLeasingPayment: {
    BE: !1,
    FR: !1,
    NL: !1,
    DEFAULT: !0
  },
  showCompanyRegistrationNumberField: {
    AT: !1,
    BE: !1,
    CH: !1,
    DE: !1,
    ES: !1,
    GB: !1,
    PT: !1,
    DEFAULT: !0
  },
  showContactSupportSectionInMyAccount: {
    AT: !0,
    BE: !0,
    CH: !0,
    DE: !0,
    ES: !0,
    FR: !0,
    GB: !0,
    IT: !0,
    NL: !0,
    PT: !0,
    DEFAULT: !1
  },
  // TODO: remove as it uses default value
  showPromotionsForLeasingPaymentType: {
    DEFAULT: !0
  },
  // NOTE: NL specific to hide EU_TireLabel classification codes
  showEUTireLabelMeasuredValueAndWetGripClasses: {
    AT: !1,
    NL: !1,
    DEFAULT: !0
  },
  showExtraEnergyLabelsCustomizer: {
    CH: !0,
    DEFAULT: !1
  },
  showGarageTabInMyAccount: {
    AT: !0,
    BE: !0,
    CH: !0,
    DE: !0,
    ES: !0,
    FR: !0,
    GB: !0,
    IT: !0,
    NL: !0,
    PT: !0,
    SE: !0,
    DEFAULT: !1
  },
  showLeasingLogotype: {
    NL: !0,
    DEFAULT: !1
  },
  showLeasingTotalAmount: {
    AT: !1,
    BE: !1,
    CH: !1,
    ES: !1,
    FR: !1,
    GB: !1,
    IT: !1,
    NL: !1,
    PT: !1,
    SE: !1,
    DEFAULT: !0
  },
  showLeasingTotalPrice: {
    BE: !1,
    DEFAULT: !0
  },
  showLeasingTransportationAndRegistrationCost: {
    AT: !1,
    BE: !1,
    ES: !1,
    FR: !1,
    GB: !1,
    IT: !1,
    NL: !1,
    DEFAULT: !0
  },
  showLeasingTransportationAndRegistrationCostInOrderOverviewSummary: {
    AT: !1,
    BE: !1,
    ES: !1,
    FR: !1,
    GB: !1,
    IT: !1,
    NL: !1,
    PT: !1,
    SE: !1,
    DEFAULT: !0
  },
  showLeasingTransportationAndRegistrationCostInVehiclePaymentDetails: {
    BE: !1,
    ES: !1,
    FR: !1,
    GB: !1,
    IT: !1,
    NL: !1,
    SE: !1,
    DEFAULT: !0
  },
  showLinkToOrderContractInMyAccount: {
    AT: !0,
    BE: !0,
    FR: !0,
    GB: !0,
    SE: !0,
    DEFAULT: !1
  },
  showListPriceForLeasingPaymentType: {
    AT: !0,
    DE: !0,
    NL: !0,
    BE: !0,
    FR: !0,
    DEFAULT: !1
  },
  showNewsletterSubscriptionInMyAccountSettings: {
    AT: !0,
    BE: !0,
    CH: !0,
    DE: !0,
    ES: !0,
    FR: !0,
    GB: !0,
    IT: !0,
    NL: !0,
    PT: !0,
    SE: !0,
    DEFAULT: !1
  },
  showOnlyTotalGrossPrice: {
    AT: !0,
    DEFAULT: !1
  },
  showOnTheRoadPriceSubtotal: {
    GB: !0,
    DEFAULT: !1
  },
  showOrdersTabInMyAccount: {
    AT: !0,
    BE: !0,
    CH: !0,
    DE: !0,
    ES: !0,
    FR: !0,
    GB: !0,
    IT: !0,
    NL: !0,
    PT: !0,
    SE: !0,
    DEFAULT: !1
  },
  showOtherPaymentTypesLabel: {
    GB: !0,
    DEFAULT: !1
  },
  showSettingsTabInMyAccount: {
    AT: !0,
    BE: !0,
    CH: !0,
    DE: !0,
    ES: !0,
    FI: !0,
    FR: !0,
    GB: !0,
    GR: !0,
    IE: !0,
    IS: !0,
    IT: !0,
    LU: !0,
    NL: !0,
    NO: !0,
    PT: !0,
    SE: !0,
    DEFAULT: !1
  },
  showSubTotalPriceForLeasingPaymentType: {
    AT: !0,
    BE: !0,
    DEFAULT: !1
  },
  showTotalEntryPriceWithDiscount: {
    AT: !0,
    DEFAULT: !1
  },
  // TODO: invert DEFAULT to be false
  showVatNumberB2C: {
    AT: !1,
    BE: !1,
    CH: !1,
    DE: !1,
    FI: !1,
    FR: !1,
    GB: !1,
    IE: !1,
    LU: !1,
    NL: !1,
    SE: !1,
    GR: !1,
    DEFAULT: !0
  },
  showVehiclePriceCashBuyOnlyWithAccessories: {
    BE: !0,
    DEFAULT: !1
  },
  showVehiclePriceForLeasingPaymentType: {
    AT: !1,
    FR: !1,
    NL: !1,
    DEFAULT: !0
  },
  showVoiceOfCustomerSurvey: {
    DE: !0,
    DEFAULT: !1
  },
  showVoiceOfCustomerInterruptionPopup: {
    DE: !0,
    DEFAULT: !1
  },
  showVehicleEffectivePrice: {
    GB: !0,
    DEFAULT: !1
  },
  useV2ContentInPaymentCalculator: {
    GB: !0,
    DEFAULT: !1
  }
}, d = (o, t, e) => {
  const i = (o == null ? void 0 : o[t]) ?? o.DEFAULT;
  return !!(i != null && i[e]);
}, m = {
  CASHBUY: {
    FR: {
      b2c: !0,
      sme: !1
    },
    DEFAULT: {
      b2c: !0,
      sme: !0
    }
  },
  FINANCE: {
    DEFAULT: {
      b2c: !1,
      sme: !1
    }
  }
}, N = ({
  marketId: o,
  customerType: t
}) => d({
  DE: {
    b2c: !1,
    sme: !0
  },
  GB: {
    b2c: !1,
    sme: !0
  },
  DEFAULT: {
    b2c: !1,
    sme: !1
  }
}, o, t), U = ({
  paymentType: o,
  marketId: t,
  customerType: e
}) => {
  const i = m == null ? void 0 : m[o];
  return i ? d(i, t, e) : !0;
}, I = ({
  marketId: o,
  customerType: t
}) => d({
  AT: {
    b2c: !0,
    sme: !0
  },
  SE: {
    sme: !1
  },
  DEFAULT: {
    b2c: !1,
    sme: !0
  }
}, o, t), G = {
  DEFAULT: {
    bold: !1,
    topBorder: !1
  }
};
function k(o, t) {
  const {
    showAdditionalLeasingOptions: e,
    showAdvancedLeasingPayment: i,
    showLeasingTotalAmount: s,
    showLeasingTransportationAndRegistrationCostInVehiclePaymentDetails: a,
    showListPriceForLeasingPaymentType: l,
    showOnTheRoadPriceSubtotal: u,
    showPromotionsForLeasingPaymentType: A,
    showSubTotalPriceForLeasingPaymentType: g,
    showTotalEntryPriceWithDiscount: P,
    showVehiclePriceCashBuyOnlyWithAccessories: p,
    showVehiclePriceForLeasingPaymentType: y,
    showVehicleEffectivePrice: C
  } = o, {
    hasAccessories: r,
    hasOnTheRoadAdditionalCosts: E,
    hasProductPromotions: n,
    hasSubsidy: f,
    hasVehicleTireTax: L,
    hasVoucher: D,
    hasWinterTireTax: b,
    isCommercialUser: S,
    paymentDataViewType: v,
    hasRefundInCanceledOrder: B
  } = t, h = !!(S && v === "pdf");
  return {
    LEASING: {
      advancedMonth: e,
      // NOTE: extended Leasing Payment data for UK market for PCH and BCH
      downPayment: i,
      excessMileage: e,
      // NOTE: extended Leasing Payment data for UK market
      interestRatePerAnnum: e,
      // NOTE: extended Leasing Payment data for UK market
      leasingDuration: !0,
      leasingPayment: !0,
      listPrice: l,
      // NOTE: extended Leasing Payment data for AT & NL market
      mileage: !0,
      onTheRoadAdditionalCosts: a,
      optionalFinalPayment: e,
      // NOTE: extended Leasing Payment data for UK market
      optionToPurchaseFee: e,
      // NOTE: extended Leasing Payment data for UK market
      packagesAttributes: P && r,
      // NOTE: AT market IBR-803: totalPrice - totalDiscount + OTR Cost
      promotions: A && n,
      representativeAPR: e,
      // NOTE: extended Leasing Payment data for UK market
      representativeExample: e,
      // NOTE: extended Leasing Payment data for UK market
      subTotalPrice: g,
      totalAmountPayable: e,
      // NOTE: extended Leasing Payment data for UK market
      totalCreditAmount: e,
      // NOTE: extended Leasing Payment data for UK market
      totalEntryPriceWithDiscount: P && r && n,
      // NOTE: AT market IBR-803: totalPrice - totalDiscount + OTR Cost
      totalLeasingCost: s,
      vehiclePrice: y || n
      // NOTE: should show vehicle price for AT, FR (WEB-5676) & NL market if there is a discount, otherwise show for others
    },
    FINANCE: {
      downPayment: i,
      excessMileage: e,
      // NOTE: extended Leasing Payment data for UK market
      interestRatePerAnnum: e,
      // NOTE: extended Leasing Payment data for UK market
      leasingDuration: !0,
      leasingPayment: !0,
      mileage: !0,
      onTheRoadAdditionalCosts: a,
      optionalFinalPayment: e,
      // NOTE: extended Leasing Payment data for UK market
      optionToPurchaseFee: e,
      // NOTE: extended Leasing Payment data for UK market
      promotions: A && n,
      representativeAPR: e,
      // NOTE: extended Leasing Payment data for UK market
      representativeExample: e,
      // NOTE: extended Leasing Payment data for UK market
      totalAmountPayable: e,
      // NOTE: extended Leasing Payment data for UK market
      totalCreditAmount: e,
      // NOTE: extended Leasing Payment data for UK market
      totalLeasingCost: s,
      vehiclePrice: !0
    },
    CASHBUY: {
      listPrice: !0,
      onTheRoadAdditionalCosts: E,
      // Vehicle Excise Duty
      onTheRoadCostsSubtotal: u,
      packagesAttributes: r,
      promotions: n,
      totalEntryPriceWithDiscount: P && r && n,
      // IBR-803: totalPrice - totalDiscount + OTR Cost
      subTotalPrice: !0,
      vehicleEffectivePrice: r || C,
      // TODO: showVehiclePriceCashBuyOnlyWithAccessories should be removed after the changes for BE after IBR-1848 is deployed
      vehiclePriceCashBuy: p ? r && !n : n && !f,
      vehiclePriceWithoutDiscount: r && !n,
      // IBR-1848: show only if accessories are added, ref: https://smarteurope.atlassian.net/wiki/spaces/SDI/pages/1491763201/BE+config
      vehicleTireTax: L,
      /* NOTE: whenever voucher is added to the orders config, make sure to delete one from the override in /src/feature-app/components/download-configuration-document/download-configuration-button.tsx
         TODO: see above NOTE
      */
      voucher: D,
      winterTireTax: b,
      totalTax: h,
      totalPriceWithTax: h,
      refund: B
    }
  };
}
const F = [
  "listPrice",
  "voucher",
  "promotions",
  "vehicleTireTax"
], H = (o) => Object.keys(o ?? {}).some((t) => {
  const e = t;
  return F.includes(e) ? o == null ? void 0 : o[t] : !1;
}), c = {
  AT: {
    vehicleDetails: {
      LEASING: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePrice: 3,
        promotions: 4,
        totalEntryPriceWithDiscount: 5,
        // IBR-838: totalPrice - totalDiscount + OTR Cost
        packagesAttributes: 6,
        subTotalPrice: 7,
        leasingDuration: 8,
        mileage: 9,
        downPayment: 10,
        leasingPayment: 11
      },
      CASHBUY: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePriceCashBuy: 3,
        promotions: 4,
        totalEntryPriceWithDiscount: 5,
        // IBR-803: totalPrice - totalDiscount + OTR Cost
        packagesAttributes: 6,
        subTotalPrice: 7
      }
    },
    orderVehicleDetails: {
      LEASING: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePrice: 3,
        promotions: 4,
        totalEntryPriceWithDiscount: 5,
        // IBR-838: totalPrice - totalDiscount + OTR Cost
        packagesAttributes: 6,
        subTotalPrice: 7,
        leasingDuration: 8,
        mileage: 9,
        downPayment: 10,
        leasingPayment: 11,
        orderPromotions: 12
      },
      CASHBUY: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePriceCashBuy: 3,
        promotions: 4,
        totalEntryPriceWithDiscount: 5,
        // IBR-803: totalPrice - totalDiscount + OTR Cost
        packagesAttributes: 6,
        subTotalPrice: 7,
        orderPromotions: 8
      }
    },
    orderSummary: {
      LEASING: {
        totalLeasingCost: 1,
        promotions: 2,
        downPayment: 3,
        annualMileageAndDuration: 4
      },
      CASHBUY: {
        promotions: 1,
        subTotalPrice: 2
      }
    },
    pdf: {
      LEASING: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePrice: 3,
        promotions: 4,
        totalEntryPriceWithDiscount: 5,
        // IBR-838: totalPrice - totalDiscount + OTR Cost
        packagesAttributes: 6,
        subTotalPrice: 7,
        leasingDuration: 8,
        mileage: 9,
        downPayment: 10,
        leasingPayment: 11
      },
      CASHBUY: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePriceCashBuy: 3,
        promotions: 4,
        totalEntryPriceWithDiscount: 5,
        // IBR-803: totalPrice - totalDiscount + OTR Cost
        packagesAttributes: 6,
        subTotalPrice: 7
      }
    }
  },
  BE: {
    vehicleDetails: {
      LEASING: {
        listPrice: 1,
        promotions: 2,
        leasingDuration: 3,
        mileage: 4,
        leasingPayment: 5,
        packagesAttributes: 6
      },
      CASHBUY: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePriceWithoutDiscount: 3,
        // IBR-1848: for BE market, vehicle price: list price + OTR costs + recycling contribution
        promotions: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    },
    orderVehicleDetails: {
      CASHBUY: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePriceWithoutDiscount: 3,
        // IBR-1848: for BE market, vehicle price: list price + OTR costs + recycling contribution
        promotions: 4,
        packagesAttributes: 5,
        subTotalPrice: 6,
        orderPromotions: 7
      },
      LEASING: {
        listPrice: 1,
        promotions: 2,
        leasingDuration: 3,
        mileage: 4,
        leasingPayment: 5,
        packagesAttributes: 6,
        orderPromotions: 7
      }
    },
    orderSummary: {
      CASHBUY: {
        subTotalPrice: 1
        // TODO: check if this is correct
      },
      LEASING: {
        leasingPayment: 1,
        promotions: 2,
        annualMileageAndDuration: 3
      }
    },
    pdf: {
      CASHBUY: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePriceWithoutDiscount: 3,
        // IBR-1848: for BE market, vehicle price: list price + OTR costs + recycling contribution
        promotions: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      },
      LEASING: {
        listPrice: 1,
        promotions: 2,
        leasingDuration: 3,
        mileage: 4,
        leasingPayment: 5,
        packagesAttributes: 6
      }
    }
  },
  DE: {
    vehicleDetails: {
      LEASING: {
        listPrice: 1,
        promotions: 2,
        totalLeasingCost: 3,
        leasingDuration: 4,
        mileage: 5,
        onTheRoadAdditionalCosts: 6,
        downPayment: 7,
        leasingPayment: 8
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    },
    orderVehicleDetails: {
      LEASING: {
        listPrice: 1,
        promotions: 2,
        totalLeasingCost: 3,
        leasingDuration: 4,
        mileage: 5,
        onTheRoadAdditionalCosts: 6,
        downPayment: 7,
        leasingPayment: 8,
        orderPromotions: 9
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        packagesAttributes: 5,
        refund: 6,
        subTotalPrice: 7,
        orderPromotions: 8
      }
    },
    orderSummary: {
      LEASING: {
        listPrice: 1,
        promotions: 2,
        totalLeasingCost: 3,
        leasingDuration: 4,
        mileage: 5,
        onTheRoadAdditionalCosts: 6,
        downPayment: 7,
        leasingPayment: 8
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    },
    pdf: {
      LEASING: {
        listPrice: 1,
        promotions: 2,
        totalLeasingCost: 3,
        leasingDuration: 4,
        mileage: 5,
        onTheRoadAdditionalCosts: 6,
        downPayment: 7,
        leasingPayment: 8
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        packagesAttributes: 5,
        subTotalPrice: 6,
        totalTax: 7,
        totalPriceWithTax: 8
      }
    }
  },
  FR: {
    vehicleDetails: {
      LEASING: {
        listPrice: 1,
        promotions: 2,
        vehiclePrice: 3,
        totalLeasingCost: 4,
        leasingDuration: 5,
        mileage: 6,
        onTheRoadAdditionalCosts: 7,
        downPayment: 8,
        leasingPayment: 9
      }
    },
    orderVehicleDetails: {
      LEASING: {
        listPrice: 1,
        promotions: 2,
        vehiclePrice: 3,
        totalLeasingCost: 4,
        leasingDuration: 5,
        mileage: 6,
        onTheRoadAdditionalCosts: 7,
        downPayment: 8,
        leasingPayment: 9
      }
    },
    orderSummary: {
      LEASING: {
        listPrice: 1,
        promotions: 2,
        vehiclePrice: 3,
        totalLeasingCost: 4,
        leasingDuration: 5,
        mileage: 6,
        onTheRoadAdditionalCosts: 7,
        downPayment: 8,
        leasingPayment: 9
      }
    },
    pdf: {
      LEASING: {
        listPrice: 1,
        promotions: 2,
        vehiclePrice: 3,
        totalLeasingCost: 4,
        leasingDuration: 5,
        mileage: 6,
        onTheRoadAdditionalCosts: 7,
        downPayment: 8,
        leasingPayment: 9
      }
    }
  },
  GB: {
    vehicleDetails: {
      LEASING: {
        leasingPayment: 1,
        promotions: 2,
        downPayment: 3,
        advancedMonth: 4,
        leasingDuration: 5,
        mileage: 6,
        optionalFinalPayment: 7,
        optionToPurchaseFee: 8,
        totalCreditAmount: 9,
        totalAmountPayable: 10,
        excessMileage: 11,
        representativeAPR: 12,
        interestRatePerAnnum: 13
      },
      FINANCE: {
        representativeExample: 1,
        leasingPayment: 2,
        promotions: 3,
        downPayment: 4,
        mileage: 5,
        leasingDuration: 6,
        vehiclePrice: 7,
        optionalFinalPayment: 8,
        optionToPurchaseFee: 9,
        totalCreditAmount: 10,
        totalAmountPayable: 11,
        excessMileage: 12,
        representativeAPR: 13,
        interestRatePerAnnum: 14
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        onTheRoadAdditionalCosts: 3,
        vehicleEffectivePrice: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    },
    orderVehicleDetails: {
      LEASING: {
        leasingPayment: 1,
        promotions: 2,
        downPayment: 3,
        advancedMonth: 4,
        leasingDuration: 5,
        mileage: 6,
        optionalFinalPayment: 7,
        optionToPurchaseFee: 8,
        totalCreditAmount: 9,
        totalAmountPayable: 10,
        excessMileage: 11,
        representativeAPR: 12,
        interestRatePerAnnum: 13,
        orderPromotions: 14
      },
      FINANCE: {
        representativeExample: 1,
        leasingPayment: 2,
        promotions: 3,
        downPayment: 4,
        mileage: 5,
        leasingDuration: 6,
        vehiclePrice: 7,
        optionalFinalPayment: 8,
        optionToPurchaseFee: 9,
        totalCreditAmount: 10,
        totalAmountPayable: 11,
        excessMileage: 12,
        representativeAPR: 13,
        interestRatePerAnnum: 14,
        orderPromotions: 15
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        onTheRoadAdditionalCosts: 3,
        packagesAttributes: 4,
        subTotalPrice: 5,
        orderPromotions: 6
      }
    },
    orderSummary: {
      LEASING: {
        leasingPayment: 1,
        promotions: 2,
        downPayment: 3,
        advancedMonth: 4,
        leasingDuration: 5,
        mileage: 6,
        optionalFinalPayment: 7,
        optionToPurchaseFee: 8,
        totalCreditAmount: 9,
        totalAmountPayable: 10,
        excessMileage: 11,
        representativeAPR: 12,
        interestRatePerAnnum: 13
      },
      FINANCE: {
        representativeExample: 1,
        leasingPayment: 2,
        promotions: 3,
        downPayment: 4,
        mileage: 5,
        leasingDuration: 6,
        vehiclePrice: 7,
        optionalFinalPayment: 8,
        optionToPurchaseFee: 9,
        totalCreditAmount: 10,
        totalAmountPayable: 11,
        excessMileage: 12,
        representativeAPR: 13,
        interestRatePerAnnum: 14
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        onTheRoadAdditionalCosts: 3,
        onTheRoadCostsSubtotal: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    },
    pdf: {
      LEASING: {
        leasingPayment: 1,
        promotions: 2,
        downPayment: 3,
        advancedMonth: 4,
        leasingDuration: 5,
        mileage: 6,
        optionalFinalPayment: 7,
        optionToPurchaseFee: 8,
        totalCreditAmount: 9,
        totalAmountPayable: 10,
        excessMileage: 11,
        representativeAPR: 12,
        interestRatePerAnnum: 13
      },
      FINANCE: {
        representativeExample: 1,
        leasingPayment: 2,
        promotions: 3,
        downPayment: 4,
        mileage: 5,
        leasingDuration: 6,
        vehiclePrice: 7,
        optionalFinalPayment: 8,
        optionToPurchaseFee: 9,
        totalCreditAmount: 10,
        totalAmountPayable: 11,
        excessMileage: 12,
        representativeAPR: 13,
        interestRatePerAnnum: 14
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        onTheRoadCostsSubtotal: 5,
        packagesAttributes: 6,
        subTotalPrice: 7
      }
    }
  },
  IT: {
    vehicleDetails: {
      LEASING: {
        vehiclePrice: 1,
        promotions: 2,
        onTheRoadAdditionalCosts: 3,
        totalLeasingCost: 4,
        leasingDuration: 5,
        mileage: 6,
        downPayment: 7,
        leasingPayment: 8
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        vehicleTireTax: 5,
        vehicleEffectivePrice: 6,
        packagesAttributes: 7,
        winterTireTax: 8,
        orderDiscount: 9,
        subTotalPrice: 10
      }
    },
    orderVehicleDetails: {
      LEASING: {
        vehiclePrice: 1,
        promotions: 2,
        onTheRoadAdditionalCosts: 3,
        totalLeasingCost: 4,
        leasingDuration: 5,
        mileage: 6,
        downPayment: 7,
        leasingPayment: 8,
        orderPromotions: 9
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        vehicleTireTax: 5,
        vehicleEffectivePrice: 6,
        packagesAttributes: 7,
        winterTireTax: 8,
        orderDiscount: 9,
        subTotalPrice: 10,
        orderPromotions: 11
      }
    },
    orderSummary: {
      LEASING: {
        vehiclePrice: 1,
        promotions: 2,
        onTheRoadAdditionalCosts: 3,
        totalLeasingCost: 4,
        leasingDuration: 5,
        mileage: 6,
        downPayment: 7,
        leasingPayment: 8
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        vehicleTireTax: 5,
        vehicleEffectivePrice: 6,
        packagesAttributes: 7,
        winterTireTax: 8,
        subTotalPrice: 9
      }
    },
    pdf: {
      LEASING: {
        vehiclePrice: 1,
        promotions: 2,
        onTheRoadAdditionalCosts: 3,
        totalLeasingCost: 4,
        leasingDuration: 5,
        mileage: 6,
        downPayment: 7,
        leasingPayment: 8
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        vehicleTireTax: 5,
        vehicleEffectivePrice: 6,
        packagesAttributes: 7,
        winterTireTax: 8,
        subTotalPrice: 9
      }
    }
  },
  NL: {
    vehicleDetails: {
      LEASING: {
        listPrice: 1,
        promotions: 2,
        leasingDuration: 3,
        mileage: 4,
        leasingPayment: 5,
        // Monthly Rate
        packagesAttributes: 6
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        onTheRoadAdditionalCosts: 3,
        vehiclePriceCashBuy: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    },
    orderVehicleDetails: {
      LEASING: {
        listPrice: 1,
        promotions: 2,
        leasingDuration: 3,
        mileage: 4,
        leasingPayment: 5,
        // Monthly Rate
        packagesAttributes: 6,
        orderPromotions: 7
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        onTheRoadAdditionalCosts: 3,
        vehiclePriceCashBuy: 4,
        packagesAttributes: 5,
        subTotalPrice: 6,
        orderPromotions: 7
      }
    },
    orderSummary: {
      LEASING: {
        leasingPayment: 1,
        // Monthly Rate
        promotions: 2,
        annualMileageAndDuration: 3
      },
      CASHBUY: {
        promotions: 1,
        subTotalPrice: 2
      }
    },
    pdf: {
      LEASING: {
        listPrice: 1,
        promotions: 2,
        leasingDuration: 3,
        mileage: 4,
        leasingPayment: 5,
        // Monthly Rate?
        packagesAttributes: 6
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        onTheRoadAdditionalCosts: 3,
        vehiclePriceCashBuy: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    }
  },
  PT: {
    vehicleDetails: {
      CASHBUY: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        promotions: 3,
        vehiclePriceCashBuy: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      },
      LEASING: {
        vehiclePrice: 1,
        promotions: 2,
        leasingDuration: 3,
        mileage: 4,
        downPayment: 5,
        leasingPayment: 6
      }
    },
    orderVehicleDetails: {
      CASHBUY: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePriceCashBuy: 3,
        packagesAttributes: 4,
        subTotalPrice: 5,
        orderPromotions: 6
      },
      LEASING: {
        vehiclePrice: 1,
        promotions: 2,
        leasingDuration: 3,
        mileage: 4,
        downPayment: 5,
        leasingPayment: 6,
        orderPromotions: 7
      }
    },
    orderSummary: {
      CASHBUY: {
        subTotalPrice: 1
        // TODO: check if this is correct
      },
      LEASING: {
        downPayment: 1,
        leasingPayment: 2,
        promotions: 3,
        annualMileageAndDuration: 4
      }
    },
    pdf: {
      CASHBUY: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        promotions: 3,
        vehiclePriceCashBuy: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      },
      LEASING: {
        vehiclePrice: 1,
        promotions: 2,
        leasingDuration: 3,
        mileage: 4,
        downPayment: 5,
        leasingPayment: 6
      }
    }
  },
  SE: {
    vehicleDetails: {
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        packagesAttributes: 4,
        subTotalPrice: 5
      },
      LEASING: {
        leasingDuration: 1,
        mileage: 2,
        downPayment: 3,
        leasingPayment: 4
      }
    },
    orderVehicleDetails: {
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        packagesAttributes: 4,
        subTotalPrice: 5,
        orderPromotions: 6
      },
      LEASING: {
        leasingDuration: 1,
        mileage: 2,
        downPayment: 3,
        leasingPayment: 4,
        orderPromotions: 5
      }
    },
    orderSummary: {
      CASHBUY: {
        subTotalPrice: 1
      },
      LEASING: {
        downPayment: 1,
        leasingPayment: 2,
        promotions: 3,
        annualMileageAndDuration: 4
      }
    },
    pdf: {
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        packagesAttributes: 4,
        subTotalPrice: 5
      },
      LEASING: {
        leasingDuration: 1,
        mileage: 2,
        downPayment: 3,
        leasingPayment: 4
      }
    }
  },
  DEFAULT: {
    vehicleDetails: {
      LEASING: {
        vehiclePrice: 1,
        promotions: 2,
        totalLeasingCost: 3,
        leasingDuration: 4,
        mileage: 5,
        onTheRoadAdditionalCosts: 6,
        downPayment: 7,
        leasingPayment: 8
      },
      FINANCE: {
        vehiclePrice: 1,
        totalLeasingCost: 2,
        leasingDuration: 3,
        mileage: 4,
        onTheRoadAdditionalCosts: 5,
        downPayment: 6,
        leasingPayment: 7
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    },
    orderVehicleDetails: {
      LEASING: {
        vehiclePrice: 1,
        promotions: 2,
        totalLeasingCost: 3,
        leasingDuration: 4,
        mileage: 5,
        onTheRoadAdditionalCosts: 6,
        downPayment: 7,
        leasingPayment: 8,
        orderPromotions: 9
      },
      FINANCE: {
        vehiclePrice: 1,
        totalLeasingCost: 2,
        leasingDuration: 3,
        mileage: 4,
        onTheRoadAdditionalCosts: 5,
        downPayment: 6,
        leasingPayment: 7,
        orderPromotions: 8
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        packagesAttributes: 5,
        subTotalPrice: 6,
        orderPromotions: 7
      }
    },
    orderSummary: {
      LEASING: {
        vehiclePrice: 1,
        promotions: 2,
        totalLeasingCost: 3,
        leasingDuration: 4,
        mileage: 5,
        onTheRoadAdditionalCosts: 6,
        downPayment: 7,
        leasingPayment: 8
      },
      FINANCE: {
        vehiclePrice: 1,
        totalLeasingCost: 2,
        leasingDuration: 3,
        mileage: 4,
        onTheRoadAdditionalCosts: 5,
        downPayment: 6,
        leasingPayment: 7
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    },
    pdf: {
      LEASING: {
        vehiclePrice: 1,
        promotions: 2,
        totalLeasingCost: 3,
        leasingDuration: 4,
        mileage: 5,
        onTheRoadAdditionalCosts: 6,
        downPayment: 7,
        leasingPayment: 8
      },
      FINANCE: {
        vehiclePrice: 1,
        promotions: 2,
        totalLeasingCost: 3,
        leasingDuration: 4,
        mileage: 5,
        onTheRoadAdditionalCosts: 6,
        downPayment: 7,
        leasingPayment: 8
      },
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    },
    demoVehicle: {
      CASHBUY: {
        listPrice: 1,
        promotions: 2,
        subTotalPrice: 3
      }
    }
  }
};
function Y(o, t, e) {
  const i = o, a = (c[i] && t in c[i] ? c[i] : c.DEFAULT)[t];
  return a ? a[e] ?? {} : {};
}
function x({
  marketId: o,
  orderConfig: t,
  shouldRemovePromotions: e
}) {
  if (!e)
    return t;
  const i = [
    "BE",
    "CH",
    "DE",
    "ES",
    "IT",
    "NL",
    "PT",
    "SE"
  ], s = ["AT"], a = { ...t };
  return i.includes(o.toUpperCase()) && (t.promotions && delete a.promotions, t.orderPromotions && delete a.orderPromotions), s.includes(o.toUpperCase()) && t.orderPromotions && delete a.orderPromotions, Object.keys(a).length !== Object.keys(t).length ? T(a) : t;
}
function O({
  marketId: o,
  orderConfig: t,
  shouldRestructureOrderConfig: e
}) {
  if (!e)
    return t;
  if (["NL", "PT"].includes(o.toUpperCase())) {
    const s = {
      listPrice: 1,
      promotions: 2,
      vehiclePriceCashBuy: 3,
      onTheRoadAdditionalCosts: 4
    }, a = { ...t };
    return Object.keys(s).forEach((u) => {
      delete a[u];
    }), T({
      ...s,
      ...a
    });
  } else
    return t;
}
function T(o) {
  return Object.keys(o).reduce((t, e, i) => (t[e] = i + 1, t), {});
}
const R = (o) => {
  if (!o || !("key" in o && "value" in o))
    return;
  const { key: t, value: e } = o;
  if (t && e) {
    if ("enabled" in e)
      return { [t]: e.enabled };
    if ("entry" in e)
      return { [t]: e.entry };
  }
}, V = (o, t) => {
  const { configs: e, key: i, envName: s } = o || {}, a = e == null ? void 0 : e.find((u) => u.key === i);
  if (!a)
    return;
  const l = t.safeParse(a);
  if (!l.success) {
    s !== "prod" && (console.log(`Error parsing config: ${i}`), console.debug(l.error));
    return;
  }
  if ("value" in a && a.value)
    return R(a);
}, M = {
  at: ["DE"],
  be: ["FR", "NL"],
  ch: ["DE", "FR", "IT"],
  de: ["DE"],
  gb: ["EN"],
  es: ["ES"],
  fr: ["FR"],
  it: ["IT"],
  nl: ["NL"],
  pt: ["PT"],
  se: ["SV"]
};
export {
  w as appMarketConfig,
  c as attributesOrderPerMarketAndPaymentTypeConfig,
  G as defaultAttributeConfig,
  F as discountPaymentAttributes,
  k as getDefaultAttributesVisibility,
  V as getFeatureAppConfig,
  Y as getPaymentConfig,
  M as hreflangCountries,
  R as parseConfig,
  H as paymentHasDiscountAttributes,
  x as removePromotionsFromOrderConfig,
  O as restructureCashBuyOrderConfig,
  N as shouldEnableEditableVatField,
  I as shouldShowVATAmountForCashBuySummaryConfig,
  U as shouldShowVATLabelForPaymentTypeConfig,
  m as vatLabelConfig
};
//# sourceMappingURL=index.mjs.map
